export default {
    printers: "printers",
    survey_icon: "survey_icon",
    chapterDotDelay: 200
};
